<template>
  <div class="stylist-description">
    <read-more-text
      v-if="hasBio"
      :text="description"
      :shrinked="shrinkDescription"
      data-test="read-more-text"
    />
    <div
      v-if="showImages"
      class="images-grid jm-my-3"
      data-test="images-container"
    >
      <div class="image-container" v-for="(url, key) in images" :key="key">
        <img class="jm-img-cover" :src="url" data-test="stylist-image" />
      </div>
    </div>
    <ShowMoreButton
      v-if="hasImages || hasBioShrink"
      class="description-show-more-btn"
      @click="shrinkDescription = !shrinkDescription"
      :active="!shrinkDescription"
      data-test="show-more-btn"
    />
  </div>
</template>

<script>
import ReadMoreText from '@/components/atoms/ReadMoreText.vue'
import ShowMoreButton from '@/components/atoms/ShowMoreButton.vue'

const SHRINK_LIMIT = 130

export default {
  name: 'StylistDescription',
  components: { ReadMoreText, ShowMoreButton },
  props: {
    description: {
      type: String,
      default: ''
    },
    images: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      shrinkDescription: true
    }
  },
  computed: {
    hasBioShrink() {
      return this.description.length > SHRINK_LIMIT
    },
    hasBio() {
      return this.description
    },
    hasImages() {
      return this.images && Object.keys(this.images).length
    },
    showImages() {
      return this.hasImages && (!this.hasBio || !this.shrinkDescription)
    }
  }
}
</script>

<style lang="scss" scoped>
.stylist-description {
  margin-left: auto;
  margin-right: auto;
  max-width: $breakpoint-m;
}

.images-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: auto;
  grid-column-gap: $spacing-2;
  grid-row-gap: $spacing-2;
  @media only screen and (min-width: $breakpoint-m) {
    grid-template-columns: repeat(4, 1fr);
  }
}

.description-show-more-btn {
  display: block;
  margin: 0 auto;
}
</style>
